import LiveBoardHomepageFirstFoldComponent from "./live-board-homepage-first-fold-component";
import LiveBoardHomepageFirstFoldConfig from "./live-board-homepage-first-fold-config";
import LiveBoardHomepageFirstFoldAdvancedConfig from "./live-board-homepage-first-fold-advanced-config";

export default {
  LiveBoardHomepageFirstFoldComponent,
  LiveBoardHomepageFirstFoldConfig,
  LiveBoardHomepageFirstFoldAdvancedConfig
};
